import React from "react";

export type TabKey = "notification" | "comp-off" | "game-booking" | "document-approvals";

interface TabItem<T> {
  k: T;
  label: string;
  /** When true, tab is visible but not selectable. */
  disabled?: boolean;
}

interface TabSelectorProps<T> {
  tabs: TabItem<T>[];
  active: T;
  onChange: (key: T) => void;
}

const TabSelector = <T extends string>({ tabs, active, onChange }: TabSelectorProps<T>) => {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="bg-white border border-slate-200 rounded-lg md:rounded-full shadow-soft px-1.5 py-1.5 flex flex-wrap gap-1">
        {tabs.map((tab) => {
          const disabled = Boolean(tab.disabled);
          return (
            <button
              key={tab.k}
              type="button"
              disabled={disabled}
              aria-disabled={disabled}
              className={`px-4 py-2 rounded-full text-xs md:text-sm font-semibold transition-colors duration-200 ${
                disabled
                  ? "cursor-not-allowed text-slate-400 opacity-60 hover:bg-transparent hover:text-slate-400"
                  : active === tab.k
                    ? "bg-primary-600 text-white shadow"
                    : "text-slate-600 hover:text-primary-600 hover:bg-primary-50"
              }`}
              onClick={() => {
                if (!disabled) onChange(tab.k);
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TabSelector;
